export default {
  en: {
    working: 'Resetting…',
    done: 'Reset',
    serverError: 'Backend did not respond',
    reset: 'Reset subscription',
  },
  ru: {
    working: 'Сбрасываю…',
    done: 'Сброшено',
    serverError: 'Бэкенд не ответил',
    reset: 'Сбросить подписку',
  },
  de: {
    working: 'Setze zurück…',
    done: 'Zurückgesetzt',
    serverError: 'Backend hat nicht geantwortet',
    reset: 'Abo zurücksetzen',
  },
  pt: {
    working: 'Redefinindo…',
    done: 'Redefinido',
    serverError: 'O backend não respondeu',
    reset: 'Redefinir assinatura',
  },
  fr: {
    working: 'Réinitialisation…',
    done: 'Réinitialisé',
    serverError: 'Le backend n’a pas répondu',
    reset: 'Réinitialiser l’abonnement',
  },
  es: {
    working: 'Restableciendo…',
    done: 'Restablecido',
    serverError: 'El backend no respondió',
    reset: 'Restablecer la suscripción',
  },
};
